import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { generateClient } from 'aws-amplify/api';
import { createTransactionSetupTable, updateTransactionSetupTable, deleteTransactionSetupTable } from '../graphql/mutations';
import { getTransactionSetupTable } from '../graphql/queries';
import { useNavigate } from "react-router-dom";

const client = generateClient();

const Setup = () => {
  const navigate = useNavigate();
  let id = useParams()?.id;
  const [status, setStatus] = useState({ message: "" });
  const [setupInfo, setSetupInfo] = useState({
    originalExternalid: "",
    externalId: "",
    weightMap: "CapturedWeight",
    imageMap: "",
    version: 0
  })

  useEffect(() => {
    async function fetchData() {
      if (id && id.length > 0) {
        const setupDetails = {
          id: id,
        };
        const result = await client.graphql({
          query: getTransactionSetupTable,
          variables: setupDetails
        });
        //const result = await DataStore.query(TransactionSetupTable, id);
        if (result) {
          const dbData = {
            originalExternalid: result.data.getTransactionSetupTable.ExternalId,
            externalId: result.data.getTransactionSetupTable.ExternalId,
            weightMap: result.data.getTransactionSetupTable.WeightMap,
            imageMap: result.data.getTransactionSetupTable.ImageMap
          };
          setSetupInfo(dbData);
        }
      }
    }
    fetchData();
  }, [id]);

  const onChange = (e) => {
    setSetupInfo({ ...setupInfo, [e.target.id]: e.target.value });
  };

  const onBlur = (e) => {
    setSetupInfo({ ...setupInfo, [e.target.id]: e.target.value.trim() });
  };

  async function updateSetup() {
    if (setupInfo.originalExternalid === setupInfo.externalId && id && id.length > 0) {

      var setupData = {
        id: id,
        ExternalId: setupInfo.externalId,
        WeightMap: setupInfo.weightMap,
        ImageMap: setupInfo.imageMap
      };
      const setupDetails = {
        ExternalId: { eq: setupInfo.externalId }
      };
      var test = await client.graphql({ query: updateTransactionSetupTable, variables: { input: setupData, condition: setupDetails } });

      setStatus({ message: 'Update Successful' });
    }
    else {
      //add
      var setupData = {
        ExternalId: setupInfo.externalId,
        WeightMap: setupInfo.weightMap,
        ImageMap: setupInfo.imageMap
      };
      await client.graphql({ query: createTransactionSetupTable, variables: { input: setupData } });
      //var success = await DataStore.save(
      //  setupData
      //);
      setStatus({ message: 'Insert Successful' });
      navigate("/setups/")
    }

    console.log("Transaction Setup saved");
  }

  async function deleteSetup() {
    if (id && id.length > 0) {
      const setupDetails = {
        id: id
      };
      const setupDetailsCondition = {
        ExternalId: { eq: setupInfo.externalId }
      };
      const deletedSetup = await client.graphql({ query: deleteTransactionSetupTable, variables: { input: setupDetails, condition: setupDetailsCondition } });
    }
  }

  const onDelete = (e) => {
    e.preventDefault();
    deleteSetup();
    setStatus({ message: 'Delete Successful' });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    updateSetup();
  };

  return (
    <form className="ui form" onSubmit={onSubmit}>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="externalId">External Id</label>
          <input type="text" className="ui fluid input" placeholder="External Id" id="externalId" value={setupInfo.externalId} onChange={onChange} onBlur={onBlur} required={true} />
        </div>
        <div className="field">
          <label htmlFor="weightMap">Weight Map</label>
          <input type="text" className="ui fluid input" placeholder="Weight Map" id="weightMap" value={setupInfo.weightMap} onChange={onChange} onBlur={onBlur} />
        </div>
        <div className="field">
          <label htmlFor="imageMap">Image Map</label>
          <input type="text" className="ui fluid input" placeholder="imageMap" id="imageMap" value={setupInfo.imageMap} onChange={onChange} onBlur={onBlur} />
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <button className="ui button" type="submit" >Submit</button>
        </div>
      </div>
      <div>{status.message}</div>
    </form>
  )
}

export default Setup;